import React from 'react';
import { translate } from 'admin-on-rest';
import WarnIcon from 'material-ui/svg-icons/alert/error-outline';

const styles = {
    card:    { background: '#fff', borderRadius: 10, boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.03)', overflow: 'hidden' },
    header:  { padding: '12px 16px', borderBottom: '1px solid #f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
    title:   { fontSize: 13, fontWeight: 700, color: '#111827', letterSpacing: 0.2, display: 'flex', alignItems: 'center', gap: 8 },
    badge:   { fontSize: 11, color: '#6b7280', background: '#f3f4f6', padding: '2px 8px', borderRadius: 999, fontWeight: 600 },
    listWrap:{ maxHeight: 360, overflowY: 'auto' },
    row:     { padding: '8px 16px', borderBottom: '1px solid #f9fafb', fontSize: 12 },
    subject: { fontWeight: 700, color: '#92400e', fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.3 },
    msg:     { color: '#374151', marginTop: 2, lineHeight: 1.4, wordBreak: 'break-word' },
    date:    { fontSize: 10, color: '#9ca3af', marginTop: 4 },
    empty:   { padding: 24, textAlign: 'center', color: '#9ca3af', fontSize: 12 },
};

export default translate(({ logs = [], nb }) => (
    <div style={styles.card}>
        <div style={styles.header}>
            <span style={styles.title}>
                <WarnIcon style={{ width: 14, height: 14, color: '#fd9512' }} />
                {nb}
            </span>
            <span style={styles.badge}>{logs.length}</span>
        </div>
        <div style={styles.listWrap}>
            {logs.length === 0 && <div style={styles.empty}>Geen meldingen</div>}
            {logs.map((record) => (
                <div key={record.id} style={styles.row}>
                    <div style={styles.subject}>[{record.subject}]</div>
                    <div style={styles.msg}>{record.message}</div>
                    <div style={styles.date}>{new Date(record.created_at).toLocaleDateString('nl-NL')}</div>
                </div>
            ))}
        </div>
    </div>
));



// WEBPACK FOOTER //
// ./src/dashboard/AdminlogList.js